import {
  differenceWith,
  cloneDeep,
  intersectionWith,
  isEqual,
  size,
  uniqBy,
  xorWith,
} from 'lodash';
import { baggageTypeOptions, carryOnBaggageTypeArray } from '../constants/ancillary-helpers';

export const getIdCode = (id) => {
  const codeInBaggage = Object.keys(baggageTypeOptions).find(key => key === id);

  if (carryOnBaggageTypeArray.includes(id)) {
    return 'CARRYON';
  }

  if (id === 'CBX') {
    return '029';
  }

  if (codeInBaggage) {
    return 'BAG';
  }

  return id;
};

export const simpleConvertToISObject = (object) => {
  const {
    currency,
    quantity,
    type,
  } = object;

  const PiItem = ['AMS', 'SXP'];

  const idAnc = getIdCode(type);
  const sku = PiItem.includes(idAnc) && 'PI';

  if (idAnc === 'BAG') {
    return {
      _id: 'BAG',
      price: object?.price || 0,
      quantity,
      sku: {
        _id: 'BAG',
      },
    };
  }
  if (object?.ancillaryOffer) {
    const price = object?.ancillaryOffer?.ancillary?.currency?.total || 0;
    return {
      _id: sku || idAnc,
      price: price,
      quantity,
      sku: {
        _id: idAnc,
      },
    };
  }

  if (object?.ancillaryOffer) {
    const price = object?.ancillaryOffer?.ancillary?.currency?.total || 0;
    return {
      _id: sku || idAnc,
      price: price,
      quantity,
      sku: {
        _id: idAnc,
      },
    };
  }
  return {
    _id: sku || idAnc,
    price: currency?.total || 0,
    quantity,
    sku: {
      _id: idAnc,
    },
  };
};

export const multipleConvertToISObject = (arrayOfObjects) => {
  // Get all the unique _id's
  const uniques = uniqBy(arrayOfObjects, 'ancillary.type');

  // get quantity from baggages
  const baggages = arrayOfObjects.filter(item => getIdCode(item.ancillary.type) === 'BAG');
  let bagItem = null;
  if (baggages.length > 0) { // if there are baggages, get the first one
    const price = baggages.reduce((acc, item) => { // get the total price of all baggages
      return acc + item?.ancillary?.currency?.total;
    }, 0);
    const quantity = baggages.reduce((acc) => {
      return acc + 1;
    }, 0);
    const priceOneBg = parseFloat((price / quantity).toFixed(2));
    bagItem = { ...baggages[0], ancillary: { ...baggages[0].ancillary, quantity: quantity, price: priceOneBg } };
  }

  const amObjectsWithQuantity = uniques.filter(e => getIdCode(e.ancillary.type) !== 'BAG').map(item => {
    const newItem = cloneDeep(item);
    newItem.ancillary.quantity = arrayOfObjects.filter(obj => obj.ancillary.type === newItem.ancillary.type).length;
    return newItem;
  });
  let allItems = [...amObjectsWithQuantity];
  if (bagItem) {
    allItems = [...allItems, bagItem];
  }
  allItems = allItems.map(el => simpleConvertToISObject(el?.ancillary));
  return allItems;
};

export const areCartsEquals = (arrIS, arrAM) => {
  const isSameSize = size(arrIS) === size(arrAM);

  return isSameSize && xorWith(arrIS, arrAM, isEqual).isEmpty;
};

export const hasCartChanges = (isCart, AMCart) => {
  const newObj = cloneDeep(AMCart);
  const amCartElm = multipleConvertToISObject(newObj);
  return !areCartsEquals(isCart, amCartElm);
};


export const getDifferences = (isCart, AMCart, activePayment = false) => {
  // Convert Objects to IS Objects
  const amCartElm = multipleConvertToISObject(AMCart);
  // Compare the two arrays
  const difISCart = differenceWith(isCart, amCartElm, isEqual);
  const difAMCart = differenceWith(amCartElm, isCart, isEqual);
  // Evaluate the differences
  const combinedObjects = [...isCart, ...amCartElm];
  const elementToUpdate = [];
  combinedObjects.forEach(obj => {
    const objFound = combinedObjects.filter(el => el?.sku?._id === obj?.sku?._id && el?.quantity !== obj?.quantity);
    if (objFound.length > 0) { elementToUpdate.push(objFound[0]); }
  });
  // Update the cart
  const updCart = intersectionWith(elementToUpdate, amCartElm, isEqual);
  const flagUpdate = updCart.length > 0;
  // Choose view Cart or Remove event
  const flagViewCart = difISCart.length >= 5;
  const listItemRemove = difISCart.map((item) => ({
    _id: item['_id'],
    price: item.price,
    quantity: 0,
  }));

  const listItemAdd = amCartElm.map((item) => ({
    _id: item['_id'],
    price: item.price,
    quantity: item.quantity,
  }));

  const listItem = listItemRemove.concat(listItemAdd);
  const objViewCar =  flagViewCart ? [{ listItem }] : [];

  return {
    ADD_TO_CART: difAMCart.map(item => ( { ...item, sendEvent: !flagUpdate } )),
    REMOVE_FROM_CART: difISCart.map(item => ( { ...item, sendEvent: flagViewCart || activePayment ? false : !flagUpdate  } )),
    UPDATE_CART: updCart,
    VIEW_CART: objViewCar,
  };
};

